import React from 'react';
import clsx from 'clsx';
function getColorCSSVar(color) {
    return `var(--spectrum-alias-color-${color}, var(--spectrum-global-color-${color}, var(--spectrum-semantic-${color}-color)))`;
}
export function Text(props) {
    const { className, tag: Tag = 'span', size = 'M', type = 'Body', children, color, } = props;
    return (React.createElement(Tag, { className: clsx(`spectrum-${type}`, `spectrum-${type}--size${size}`, className), style: Object.assign(Object.assign({}, (color && {
            color: getColorCSSVar(color),
        })), props.style) }, children));
}
